export default __webpack_public_path__ + "static/media/restobizLogo.d9243240.png";